import { createStore, applyMiddleware, Store, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import authReducer from './auth/reducers';
import customerReducer from './customer/reducers';
import { LOGOUT } from './auth/types';
import sidebarReducer from './sidebar/reducer';
import settingReducer from './setting/reducers';

const appReducer = combineReducers({
    auth: authReducer,
    customerDetail: customerReducer,
    sidebar: sidebarReducer,
    setting: settingReducer,
});

export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (state: any, action: any) => {
    if (action.type === LOGOUT) {
        // eslint-disable-next-line no-param-reassign
        state = undefined;
    }
    return appReducer(state, action);
};

/**
 * Configure redux store
 */
export default async function configureStore() {
    const middlewares = [thunkMiddleware];
    const middlewareEnhancer = applyMiddleware(...middlewares);
    const preLoadedState: Partial<RootState> = {};
    const store: Store = createStore(
        rootReducer,
        preLoadedState,
        composeWithDevTools(middlewareEnhancer),
    );
    return store;
}
